import { isFunction } from "lodash";
import { useCallback, useState } from "react";
import { MdInfo, MdKeyboardBackspace } from "react-icons/md";
import Button from "./Button";

const ActionButtons = ({
  onNext,
  onBack,
  disabled = false,
  nextText = "Continuer",
  backText = "Retour",
  nextProps = {},
  backProps = {},
  infoText,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const externalLoading = Boolean(nextProps.loading);

  const isLoading = isSubmitting || externalLoading;
  const isNextDisabled =
    disabled || nextProps.disabled || isSubmitting || externalLoading;

  const handleNext = useCallback(async () => {
    if (!isFunction(onNext) || isNextDisabled) return;

    setIsSubmitting(true);
    try {
      await Promise.resolve(onNext());
    } finally {
      setIsSubmitting(false);
    }
  }, [isNextDisabled, onNext]);

  return (
    <div className="miltis__actions">
      {isFunction(onBack) && (
        <Button
          type="primary--link"
          className="miltis__actions--back"
          onClick={onBack}
          disabled={isSubmitting || backProps.disabled}
          {...backProps}
        >
          <MdKeyboardBackspace />
          <span>{backText}</span>
        </Button>
      )}
      {isFunction(onNext) && (
        <div className="miltis__actions--primary">
          <Button
            block
            type="primary"
            className="miltis__actions--next"
            onClick={handleNext}
            {...nextProps}
            disabled={isNextDisabled}
            loading={isLoading}
          >
            {nextText}
          </Button>
          {infoText && (
            <div className="miltis__actions--info">
              <MdInfo size={24} />
              <p dangerouslySetInnerHTML={{ __html: infoText }} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ActionButtons;
